import React from 'react';
import cn from 'classnames';
import styles from './index.module.less'
import { tagsConfig } from 'mod/product/config'
import { IStyleConfig } from 'base/interfacesV2/feature'
import { IProduct, TDiscountStyle } from 'mod/product/interface';
import { getDiscountText, getTagElStyles } from 'mod/product/utils';
import Image from '@base/lib/ThemeImage'
import { useTrans } from 'base/utils/i18n'

type IProps = {
    tagConfig?: IStyleConfig;
    discount?: IProduct['discount'];
    discountStyle?: TDiscountStyle;
    className?: string;
}

const SuperFlashSaleOffTag: React.FC<IProps> = (props) => {

    const { tagConfig, discount, className, discountStyle } = props;

    const { icon, title, tagType } = tagConfig || {}
    const { t } = useTrans();

    const _tagType = tagType?.toLowerCase() || tagType || ''
    const defaultConfig = tagsConfig.product[_tagType || ''] || {};

    return (
        <div
            className={cn(
                styles.tag,
                className,
                'js-product-tag js-full overflow',
            )}
            style={getTagElStyles(tagConfig)?.wrapStyle}
        >
            <div
                className="text g-text flex flex-middle"
                style={getTagElStyles(tagConfig)?.titleStyle}
            >
                {!!icon && (
                    <Image
                        className={styles.icon}
                        fixed
                        background={false}
                        src={icon}
                        width={12}
                        height={12}/>
                )}
                <span>{title || t(defaultConfig?.text || '')}</span>
            </div>
            <div
                className="off g-off"
                style={getTagElStyles(tagConfig)?.descStyle}
            >
                {!!discount && getDiscountText(discount, discountStyle)}
            </div>
        </div>
    );
};

export default SuperFlashSaleOffTag